"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var SHOPIFY_API_BASE = 'shopify/v1/';

var ShopifyApi =
/*#__PURE__*/
function () {
  function ShopifyApi() {
    (0, _classCallCheck2.default)(this, ShopifyApi);
  }

  (0, _createClass2.default)(ShopifyApi, null, [{
    key: "fetchShopifyStoreStatuses",
    value: function fetchShopifyStoreStatuses() {
      return _apiClient.default.get(SHOPIFY_API_BASE + "/connection-status-per-store");
    }
  }]);
  return ShopifyApi;
}();

exports.default = ShopifyApi;
module.exports = exports.default;